import { render, staticRenderFns } from "./UnallocatedAbmDevices.vue?vue&type=template&id=2b9e5c58&scoped=true&"
import script from "./UnallocatedAbmDevices.vue?vue&type=script&lang=js&"
export * from "./UnallocatedAbmDevices.vue?vue&type=script&lang=js&"
import style0 from "./UnallocatedAbmDevices.vue?vue&type=style&index=0&id=2b9e5c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e5c58",
  null
  
)

export default component.exports